import React from 'react'
import './Footer.css';

function Footer() {
    return (
      <div className="footer  text-center">
        <div className="part1">
          <h5>SUBSCRIBE TO NEWSLETTER</h5>
          <div className="footer-email">
            <input type="email" placeholder="E-mail address" />
          </div>
          <button>SEND</button>
          <div className="footer-social">
            <i className="fab fa-instagram-square"></i>
            <i className="fab fa-twitter-square"></i>
            <i className="fab fa-facebook-square"></i>
            <i className="fab fa-snapchat-square"></i>
            <i className="fab fa-google-plus-square"></i>
          </div>
        </div>
        <div className="part2 ">
          <p>
            © Allrights reserved-Designed by <span>Aly Abd-Elhady</span>
          </p>
        </div>
      </div>
    );
}

export default Footer
